// 定义图片支持的格式
const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
// 定义视频支持的格式
const videoExtensions = ['.mp4', '.mov', '.avi'];

/**
 * 通过文件原名称判断是否符合图片文件
 * @param fileName 文件原名称
 * @returns {boolean} true/false
 */
function isImage(fileName) {
  const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
  return imageExtensions.includes(extension);
}

/**
 * 通过文件原名称判断是否符合视频文件
 * @param fileName 文件原名称
 * @returns {boolean} true/false
 */
function isVideo(fileName) {
  const extension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
  return videoExtensions.includes(extension);
}

export { isImage, isVideo };
